import { BaseModel } from './base.model'
import { Lesson } from './lesson.model'

export class LessonText extends BaseModel<LessonText> {
  static DEFAULT_ATTRIBUTES = {}

  comment: string
  content: string
  folderId: number
  id: number
  lessons: Lesson[]
  name: string
  state: string
  timeLimit: number

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }

  get timeLimitMinutes(): number {
    if(this.timeLimit) {
      return Math.round(this.timeLimit / 60 * 100) / 100
    } else {
      return this.timeLimit
    }
  }

  set timeLimitMinutes(minutes: number) {
    this.timeLimit = minutes ? minutes * 60 : minutes
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/lesson-text.model.ts